const initialState = {
  facfrs: [],
};
export default function (state = initialState, action) {
  switch (action.type) {
    case "FACTURE_FRS_SELECT":
      return {
        ...state,
        facfrs: action.payload,
      };
    default:
      return state;
  }
}
